declare var require: any;
import './pagination.template.html';
import { paginationController } from './pagination.controller'

export var paginationComponent = {
    template: require('./pagination.template.html'),
    controller: paginationController,
    bindings: {
        pageNumber: '=',
        pageSize: '=',
        totalItems: '=',
        pageChange: '&',
        selfPageChange: '<'
    }
}


// WEBPACK FOOTER //
// ./src/components/pagination/pagination.ts